/**
* @requires ./../assets/_jquery.js
* @requires ./../assets/accessibility/_accessibility.js
* @requires ./../assets/slick/_slick.js
* @requires ./../include/header-mobile/_header-mobile.js
* @requires ./../include/home-slider/_home-slider.js
* @requires ./../include/home-about/_home-about.js
* @requires ./../include/home-links-group/_home-links-group.js
* @requires ./../include/home-banner/_home-banner.js
* @requires ./../include/home-news/_home-news.js
* @requires ./../include/home-bottom/_home-bottom.js
* @requires ./../include/section-text/_section-text.js
* @requires ./../include/section-staff/_section-staff.js
* @requires ./../include/section-simple-links/_section-simple-links.js
* @requires ./../include/section-visual-links/_section-visual-links.js
* @requires ./../include/section-download-files/_section-download-files.js
* @requires ./../include/single-inner-staff/_single-inner-staff.js
* @requires ./../include/sidebar/_sidebar.js
* @requires ./../include/template-staff-inner/_template-staff-inner.js
* @requires ./../include/section-form/_section-form.js
* @requires ./../include/home-content-area/_home-content-area.js
* @requires ./../include/template-jobs-inner/_template-jobs-inner.js
 *

/*script*/
function mobileOnlySlider() {
    $('.wrap-all-news').slick({
        'rtl' : true,
        // 'arrows' : false,
        'dots' : false,
        // 'fade' : true,
    });
}
$(document).ready(function() {
    headerMobile();
    homeLinksGroup()
    homeNews()
    // if ( $('body').hasClass('page-tactiveemplate-ptm-homepage') ) {
    homeSlider();
    sidebarMenu();
    sectionForm();
    homeBanner();
    templateJobsInner();

    // var $header = $("header"),
    // $clone = $header.before($header.clone().addClass("clone"));
    //
    // $(window).on("scroll", function() {
    //     var fromTop = $("body").scrollTop();
    //     $('body').toggleClass("down", (fromTop > 200));
    // });
    $(window).scroll(function(){

        if ($(window).scrollTop() >= 1) {
            $('#header-wrap').addClass('sticky');
            // $('nav div').addClass('visible-title');
        }
        else {
            $('#header-wrap').removeClass('sticky');
            // $('nav div').removeClass('visible-title');
        }
        if($(window).scrollTop() > 530){
            $('#header-wrap .nav-wrap').addClass('no-opacity');
        }else{
            $('#header-wrap .nav-wrap').removeClass('no-opacity');
        }

    });

    //table jobs accessibility

    $('body').on('click', '.wrapper-job .wrap-job', function() {

        if ($(this).parent('.wrapper-job').hasClass('active')) {
            $(this).parent('.wrapper-job').removeClass('active');
            $(this).children("[class^='col']").children("span").attr("aria-expanded","false");
            $(this).children("[class^='col']").children("span").attr("aria-label","לחץ לפתיחת פירוט משרה");

        } else {
            $(this).parent('.wrapper-job').addClass('active');
            $(this).children("[class^='col']").children("span").attr("aria-expanded","true");
            $(this).children("[class^='col']").children("span").attr("aria-label","לחץ לסגירת פירוט משרה");

            var text = $(this).find('.col-3').text();
            $("body #positionForm").attr("data-pos",text);

            if ($(this).parents('.all-jobs').hasClass('tendertab')) {
                text = $(this).find('.col-4').text();
                $("body #positionFormInternal").attr("data-pos",text);
            }
          // $("#positionForm .hr-job input[value='position-name']").val(text);
        }
        $(this).parent('.wrapper-job').children('.wrap-inner-job').slideToggle();
    });



   $("#positionForm .close, #positionFormInternal .close").click(function(event) {
     setTimeout(function(){
           location.reload();
      }, 300);
   });

   $(".overlay").click(function(e) {
       var popup = $(".popup");

       if (!popup.is(e.target) && popup.has(e.target).length === 0)
       {
         window.location.href = '#';
         setTimeout(function(){
               location.reload();
          }, 300);
        }
   });


    $('body').on('click', 'a.ApplyFor', function() {
      var h2='';
      var pos = $("body #positionForm").attr("data-pos");

    if(($(this).parents('.wrapper-job').find('.col-2').text() == '') && ($(this).parents('.wrapper-job').length == 1)){
       var date = $(this).parents('.wrapper-job').find('.col-1').text();
       var h2 = '<h2>'+date +'</h2><h2>'+pos+'</h2>';
   }else if ($(this).parents('.wrapper-page-job').length == 1 ){
       pos = $(this).parents('.wrapper-page-job').find('.header-job').attr("data-pos");
       var posID = $(this).parents('.wrapper-page-job').find('.position-details').attr('data-job');
       var faculty= $(this).parents('.wrapper-page-job').find('.header-job').attr('data-faculty');
       var h2 = '<h2>הגשת מועמדות למשרה ' +posID +'-'+ pos +' </h2> <h2> - '+ faculty +'</h2>';
   }else{
       var posID = $(this).parents('.wrapper-job').find('.position-details').attr('data-job');
       var faculty= $(this).parents('.wrapper-job').find('.col-2').text();
       var h2 = '<h2>הגשת מועמדות למשרה ' +posID +'-'+ pos +' </h2> <h2> - '+ faculty +'</h2>';
     }
     var contact= '';
     // if($(this).parents('.wrapper-job').length == 1){
     if($(this).parents('.template-jobs-inner').length == 1){
        contact = $(this).parents('.wrapper-job').attr("data-contact");
        $("#positionForm input[value='form-destination']").val('משרות סטודנטים');
     }
     if ($(this).parents('.all-jobs').hasClass('tendertab')) {
         console.log('yes insert now');
         var pos = $("body #positionFormInternal").attr("data-pos");
         var posID = $(this).parents('.wrapper-job').find('.position-details').attr('data-job');
         var faculty= $(this).parents('.wrapper-job').find('.col-3').text();
         var h2 = '<h2>הגשת מועמדות למשרה ' +posID +'-'+ pos +' </h2> <h2> - '+ faculty +'</h2>';
         $("#positionFormInternal .gform_body").prepend(h2);
         var input_po_name = $("#positionFormInternal input[value='position-name']");
     }else if($(this).parents('.wrapper-page-job').length == 1 && ($(this).parents('.wrapper-page-job').hasClass('internal-job'))) {
         $("#positionFormInternal .gform_body").prepend(h2);
         var input_po_name = $("#positionFormInternal input[value='position-name']");
     }else {
         $("#positionForm .gform_body").prepend(h2);
         var input_po_name = $("#positionForm input[value='position-name']");
     }
       input_po_name.val(pos);
       if(contact!= ''){
          $("#positionForm input[value='mail address']").val(contact);
        }

    });

    $('#access-plug').accessPlug({
        contrastLight: true,
        lang : "he",
        responsive: {
            mobilePos: $('#access-plug-mobile'),
            desktopPos: $('#access-plug')
        }
    });
    // $("header .search, .header-mobile .links .").click(function(event) {
    $(".header-mobile .links .search").click(function(event) {
        $(this).parent('.wrap-search').children('#search').slideToggle();
        var el=$(this);
        setTimeout(function(){
            header_accessibility(el);
        },500);
    });

    $("header .search").click(function(event) {
        console.log('insert');
        if ($(this).parent('.wrap-search').children('#search').hasClass('hide')) {
            $(this).parent('.wrap-search').children('#search').removeClass('hide')
        } else {
            $(this).parent('.wrap-search').children('#search').addClass('hide');
        }
        var el=$(this);
        setTimeout(function(){
            header_accessibility(el);
        },200);
    });

    $("a.li-link.wrap-search>span").keydown(function(e){
        if(e.which==13){
            $(this).click();
        }
    });

      $('body').on('focus', '.gform_wrapper form input', function() {
        if($(this).attr('type')=='radio'){
            $(this).parents(".ginput_container").next().remove();
        }else{
          if($(this).attr('type')!='submit'){
            $(this).parent().next().remove();
          }
        }
      });

    $('body').on('focus', '.gform_wrapper form input[type="text"]', function() {

        // $( ".gform_wrapper form input[type='text']" ).focus(function() {
        $(this).parent().prev('label').css('transform','translate(0, 1rem)');
        $(this).parent().prev('label').addClass('fillIn');
        $(this).addClass('inputfillIn');
    });
    $('body').on('focusout', '.gform_wrapper form input[type="text"]', function() {
        // $( ".gform_wrapper form input[type='text']" ).focusout(function() {

        if($(this).val() == ''){
            $(this).parent().prev('label').css('transform','translate(0, 4rem)');
            $(this).parent().prev('label').removeClass('fillIn');
            $(this).removeClass('inputfillIn');
        }
    });
    $('body').on('focus', '.gform_wrapper form textarea', function() {
        // $( ".gform_wrapper form textarea" ).focus(function() {
        $(this).parent().prev('label').css('transform','translate(0, 4rem)');
        $(this).parent().prev('label').addClass('fillIn');
        $(this).addClass('inputfillIn');
    });
    $(".gform_wrapper form textarea").parent().prev('label').css('transform','translate(0, 8.5rem)');

    $('body').on('focusout', '.gform_wrapper form textarea', function() {
        // $( ".gform_wrapper form textarea" ).focusout(function() {
        if($(this).val() == ''){
            $(this).parent().prev('label').css('transform','translate(0, 8.5rem)');
            $(this).parent().prev('label').removeClass('fillIn');
            $(this).removeClass('inputfillIn');
        }
    });
    $('body').on('change', '.gform_wrapper form select', function(event) {
        // $( ".gform_wrapper form select").change(function(event) {
        if($(".gfield_select option:selected").val()!= ''){
            $(".gfield_select").css("color","#000");
            $(this).parent().prev('label').css('transform','translate(0, 1rem)');
            $(this).parent().prev('label').addClass('fillIn');
            $(this).addClass('inputfillIn');
        }else{
            $(".gfield_select").css("color","transparent");
            $(this).parent().prev('label').css('transform','translate(0, 4rem)');
            $(this).parent().prev('label').removeClass('fillIn');
            $(this).addClass('inputfillIn');
        }
    });

    // $(window).on('resize load', function() {
    //     if ($(window).width() <= 768) {
    //         if ($("#header-wrap #header .links a.accessible > div").is("#access-plug")) {
    //             $('#header-wrap #header .links a.accessible > div').removeAttr('id');
    //         }
    //         if (! $(".header-mobile .offcanvas .links a.accessible > div").is("#access-plug")) {
    //             $('.header-mobile .offcanvas .links a.accessible > div').attr('id', 'access-plug');
    //         }
    //     } else {
    //         if (! $("#header-wrap #header .links a.accessible > div").is("#access-plug")) {
    //             $('#header-wrap #header .links a.accessible > div').attr('id', 'access-plug');
    //         }
    //         if ($(".header-mobile .offcanvas .links a.accessible > div").is("#access-plug")) {
    //             $('.header-mobile .offcanvas .links a.accessible > div').removeAttr('id');
    //         }
    //     }
    // });
    // $(window).resize(function(e){
    $(window).on('resize, load',  function(event) {
        if(window.innerWidth < 768) {
            if(!$('.wrap-all-news').hasClass('slick-initialized')){
                mobileOnlySlider();
            }
        }else{
            if($('.wrap-all-news').hasClass('slick-initialized')){
                $('.wrap-all-news').slick('unslick');
            }
        }
        jobsStudentTableToList();
    });
    $(window).on('load',  function(event) {

        // setTimeout(function(){
        // repeater forth-travel
        $('.forth-travel table tbody > tr td').each(function() {
            var input = $(this).children('input');
            var name = input.attr('name');
            var label = input.attr('aria-label');
            input.before('<label class="gfield_label" for="'+name+'" style="transform: translate(0px, 4rem);">'+label+'</label>');
            input.wrap('<div class="ginput_container ginput_container_text"></div>');
        });
        // repeater back-travel
        $('.back-travel table tbody > tr td').each(function() {
            var input = $(this).children('input');
            var name = input.attr('name');
            var label = input.attr('aria-label');
            input.before('<label class="gfield_label" for="'+name+'" style="transform: translate(0px, 4rem);">'+label+'</label>');
            input.wrap('<div class="ginput_container ginput_container_text"></div>');
        });
        // }, 2000);
        $('body').on('click', 'table tbody > tr td .add_list_item', function() {
            // $( "table tbody > tr td .add_list_item" ).on( "click",  function() {
            var td = $(this).parents('tr').next('tr').children('td');
            td.each(function() {
                input = $(this).find('input');
                label = $(this).find('label');
                if(label.hasClass('fillIn')) {
                    label.css('transform','translate(0, 4rem)');
                    label.removeClass('fillIn');
                }
                if(input.hasClass('inputfillIn')) {
                    input.removeClass('inputfillIn');
                }
                var name = input.attr('name');
                // var label = input.attr('aria-label');
            });
            // }, 2000);
            // setTimeout(function(){
            //     console.log('settimeout');
            // td.each(function() {
            //     var input = $(this).children('input');
            //     var name = input.attr('name');
            //     var label = input.attr('aria-label');
            //     input.before('<label class="gfield_label" for="'+name+'" style="transform: translate(0px, 4rem);">'+label+'</label>');
            //     input.wrap('<div class="ginput_container ginput_container_text"></div>');
            // });
            // }, 2000);
        });

        // var num= 1;
        $('.desktop-menu > li').each(function() {
            if ($(this).children('.sub-menu')) {
                var subMenu = $(this).children('.sub-menu');
                var subMenuOffset = subMenu.offset();
                if (subMenuOffset) {
                    subMenuOffSetLeft = subMenuOffset.left;
                    if(subMenuOffSetLeft<0) {
                        $(this).children('.sub-menu').addClass('left-sub-menu');
                        $(this).parents('.sub-menu').addClass('left-sub-menu');
                    }
                }
                var li =$(this).children('.sub-menu');
                li.find('.sub-menu').children('li').each(function() {
                    var subMenu = $(this);
                    var subMenuOffset = subMenu.offset();
                    if (subMenuOffset) {
                        subMenuOffSetLeft = subMenuOffset.left;
                        if(subMenuOffSetLeft<0) {
                            $(this).children('.sub-menu').addClass('left-sub-menu');
                            $(this).parents('.sub-menu').addClass('left-sub-menu');
                            var right = $(this).parents('.sub-menu').css('right');
                            var new_right = right + (subMenuOffSetLeft*(parseInt(-1)));
                            $(this).parents('.sub-menu').css('right',new_right);
                        }
                    }
                    if ($(this).children('.sub-menu')) {
                        var subMenu = $(this).children('.sub-menu');
                        var subMenuOffset = subMenu.offset();
                        if (subMenuOffset) {
                            subMenuOffSetLeft = subMenuOffset.left;
                            if(subMenuOffSetLeft<0) {
                                // if((subMenuOffSetLeft + (-30))<0) {
                                $(this).children('.sub-menu').addClass('left-sub-menu');
                                $(this).parents('.sub-menu').addClass('left-sub-menu');
                            }
                        }
                    }
                });
                // num++;
            }
        });

    });
    // $(".fancybox").fancybox();


    /////////////////////////////////////////////////////////////////////////////////////////////
    //accessibility

    //links

    //.pdf
    $("a[href$='.pdf']").each(function(){
        var a_lbl=$(this).attr("aria-label");
        if(a_lbl==undefined)
            a_lbl=$(this).text();

        $(this).attr("aria-label",a_lbl+" "+"קובץ"+" pdf");
    });

    //youtube
    $("[href*='youtube']").each(function(){
        var a_lbl=$(this).attr("aria-label");
        if(a_lbl==undefined)
            a_lbl=$(this).text();
        $(this).attr("aria-label",a_lbl+" "+"נפתח ביוטיוב");
    });

    //google forms
    $("[href*='docs.google.com/forms']").each(function(){
        var a_lbl=$(this).attr("aria-label");
        if(a_lbl==undefined)
            a_lbl=$(this).text();
        $(this).attr("aria-label",a_lbl+" "+"google forms");
    });

    //.doc
    $("a[href$='.doc']").each(function(){
        var a_lbl=$(this).attr("aria-label");
        if(a_lbl==undefined)
            a_lbl=$(this).text();
        $(this).attr("aria-label",a_lbl+" "+"קובץ"+" doc");
    });
    //נפתח בכרטסיה חדשה
    $("[target='_blank']").each(function(){
        var a_lbl=$(this).attr("aria-label");
        if(a_lbl==undefined)
            a_lbl=$(this).text();
        $(this).attr("aria-label",a_lbl+" "+"נפתח בכרטסיה חדשה");
    });

    //הפניה לאתר חדש
    $('a[href^="http://"]:not([href*="technion"]),a[href^="https://"]:not([href*="technion"])').each(function(){
        var a_lbl=$(this).attr("aria-label");
        if(a_lbl==undefined)
            a_lbl=$(this).text();
        $(this).attr("aria-label",a_lbl+" "+"מפנה לאתר חיצוני");
    });

    //download
    $("[download]").each(function(){
        var a_lbl=$(this).attr("aria-label");
        if(a_lbl==undefined)
            a_lbl=$(this).text();
        $(this).attr("aria-label",a_lbl+" "+"לחץ להורדה");
    });

    //מייל וטלפון
    $("a[href^=mailto]").each(function(){
        $(this).attr("aria-label"," כתובת מייל "+$(this).text())
    });
    $("a[href^=tel]").each(function(){
        $(this).attr("aria-label"," מספר טלפון "+$(this).text())
    });



    //menu
    $("#access>.desktop-menu>li.menu-item.menu-item-type-post_type.menu-item-object-page>a[href^=https]").attr("role","link");

    $("#access ul li > ul").focusin(function(){
        $(this).css({"pointer-events": "all","opacity": "1"});
    });
    $("#access ul li > ul").focusout(function(){
        $(this).css({"pointer-events": "","opacity": ""});
    });

    //menu definition
    $("#header #access>ul").attr({"role":"menubar"});
    $("#header #access>ul>li").attr("role","none");
    $("#header #access>ul>li>a").attr({"role":"menuitem"});
    $("#header #access>ul>li>.sub-menu").attr({"role":"menu"});
    $("#header #access>ul>li>.sub-menu>li").attr({"role":"none"});
    $("#header #access>ul>li>.sub-menu>li>a").attr({"role":"menuitem"});
    $("#header #access>ul>li>.sub-menu>li>.sub-menu>li").attr({"role":"none"});
    $("#header #access>ul>li>.sub-menu>li>.sub-menu>li>a").attr({"role":"menuitem"});


    $(".wrap-search").keydown(function (e) {//דלג בניווט על האלמנטים בתפריט הנגישות אם תפריט הנגישות סגור
        if(e.which === 9  && e.shiftKey && $('#access-plug.menu-open').length==0)
        {
            // e.preventDefault();
            $("#access-container ul").css("display","none");
            setTimeout(function () {
                $("#access-container ul").css("display","block");
            },200);
        }
    });

    //כשתפריט נגישות פתוח בלחיצה על שיפט+טאב על כפתור פתיחת התפריט חזור לפריט האחרון בתפריט
    $(".accessibility-menu-view-toggle").keydown(function(e){
        if($(".accessibility-menu[aria-hidden=false]").length>0){
            if(e.which === 9  && e.shiftKey)
            {
                e.preventDefault();
                $(".accessibility-menu-conatiner .accessibility-menu .accessibility-menu-item[tabindex]:last").focus();
            }
        }
    });
    //כשתפריט נגישות פתוח בלחיצה על טאב על הפריט האחרון בתפריט חזור לפריט הראשון בתפריט
    $(".accessibility-menu-conatiner .accessibility-menu .accessibility-menu-item[tabindex]:last").focusout(function(e){
        var el=document.querySelector("#header .li-link.wrap-search>.search");
        if(e.relatedTarget==el)
        {
            e.preventDefault();
            $(".accessibility-menu-view-toggle").focus();
        }
    });

});
function header_accessibility(el){
    if(el.siblings("#search").css("display")=="none"){
        el.attr("aria-expanded","false");
    }
    else{
        el.attr("aria-expanded","true");
        $("#search input[type=text]").focus();
    }
}
